export const RELOAD_OFFER_LOGS_QUERY = require("./reloadOfferLogsQuery.graphql");
export const LOAD_CATEGORIES_QUERY = require("./loadCategoriesQuery.graphql");
export const LOAD_CATEGORIES_SUBSCRIPTION_COUNTS_QUERY = require("./loadCategoriesSubscriptionsCountsQuery.graphql");
export const LOAD_CATEGORY_QUERY = require("./loadCategoryQuery.graphql");
export const LOAD_ZONES_QUERY = require("../../../../../../Common/js/components/graphql/queries/loadZonesQuery.graphql");
export const LOAD_OFFERS_QUERY = require("./loadOffersQuery.graphql");
export const LOAD_OFFER_DUPLICATES_QUERY = require("./loadOfferDuplicatesQuery.graphql");
